import React, { useState } from 'react'
import waco from '../service/waco';
import downArrow from '../assets/images/downArrow.png';

var medOne;
var medTwo;

const MedSwitch = ({ content, setSwitch }) => {

    let c = content;
    let medications = waco.getVariable("medications").sort();

    const [isDiscontinue, setDiscontinue] = useState(false);
    const [buttonColorDis, setColorDis] = useState("#F6D25C");
    const [buttonColorSwi, setColorSwi] = useState("#f9f1d3ff");

    let onChange1 = (event) => {
        medOne = event.target.value;
        setSwitch("medOne", medOne);
    }

    let onChange2 = (event) => {
        medTwo = event.target.value;
        setSwitch("medTwo", medTwo);
    }

    let discontinuePressed = (isPressed) => {
        if(isPressed == true) {
            setDiscontinue(true);
            setSwitch("medOne", "Discontinuation");
            setColorDis("#f9f1d3ff")
            setColorSwi("#F6D25C")
        } else {
            setDiscontinue(false);
            setSwitch("medOne", "");
            setSwitch("medTwo", "");
            setColorDis("#F6D25C")
            setColorSwi("#f9f1d3ff")
        }
    }

    return (
        <div className={"card "} style={{padding:"20px 10px"}}>
            {(medications.includes("Discontinuation")) ? 
                <div>
                    <button style={{whiteSpace:"nowrap", padding:"5px 10px 5px 10px", minHeight:"0px", marginRight:"20px", textAlign:"center", backgroundColor:buttonColorDis, borderColor:"#F6D25C", color:"#212121"}} onClick={e => discontinuePressed(false)} className="btn btn-primary">Switching</button>
                    <button style={{whiteSpace:"nowrap", padding:"5px 10px 5px 10px", minHeight:"0px", textAlign:"center", backgroundColor:buttonColorSwi, borderColor:"#F6D25C", color:"#212121"}} onClick={e => discontinuePressed(true)}className="btn btn-primary">Discontinuation</button>
                    {(isDiscontinue)?
                    <div>
                        <div style={{padding:"10px"}}>
                            <select className="form-control" id={c.id} onChange={onChange2}> 
                                <option key="Select" value="Select">Select Medication</option>
                                {medications.map(med => {
                                    if(med=="Discontinuation"){
                                        
                                    } else {
                                        med = med.replaceAll("\'", "");
                                        return (<option key={med} value={med}>{med}</option>);
                                    }
                                })}
                            </select>
                        </div>
                        </div>:
                    <div>                                
                        <div style={{padding:"10px"}}>
                            <select className="form-control" id={c.id} onChange={onChange1}> 
                                <option key="Select" value="Select">Select Medication</option>
                                {medications.map(med => {
                                    if(med=="Discontinuation"){
                                        
                                    } else {
                                        med = med.replaceAll("\'", "");
                                        return (<option key={med} value={med}>{med}</option>);
                                    }
                                })}
                            </select>
                        </div>
                        <div align="center"><img style={{height:"25px"}} src={downArrow}/></div>
                        <div style={{padding:"10px"}}>
                            <select className="form-control" id={c.id} onChange={onChange2}> 
                                <option key="Select" value="Select">Select Medication</option>
                                {medications.map(med => {
                                    if(med=="Discontinuation"){
                                        
                                    } else {
                                        med = med.replaceAll("\'", "");
                                        return (<option key={med} value={med}>{med}</option>);
                                    }
                                })}
                            </select>
                        </div>
                    </div>}
                </div>:
                <div>
                    <div style={{padding:"10px"}}>
                        <select className="form-control" id={c.id} onChange={onChange1}> 
                            <option key="Select" value="Select">Select Medication</option>
                            {medications.map(med => {
                                med = med.replaceAll("\'", "");
                                return (<option key={med} value={med}>{med}</option>);
                            })}
                        </select>
                    </div>
                    <div align="center"><img style={{height:"25px"}} src={downArrow}/></div>
                    <div style={{padding:"10px"}}>
                        <select className="form-control" id={c.id} onChange={onChange2}> 
                            <option key="Select" value="Select">Select Medication</option>
                            {medications.map(med => {
                                med = med.replaceAll("\'", "");
                                return (<option key={med} value={med}>{med}</option>);
                            })}
                        </select>
                    </div>
                </div>}
        </div>)
};

export default MedSwitch